// src/components/NewVisit

// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ErrorAlert, PageLoadingSpinner } from 'ui_kit_qmd'
import { useLocation, useNavigate } from 'react-router-dom'
import './NewVisit.scss'
import _ from 'lodash'
import errorIcon from '../../images/common/error-icon.svg'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { AVAILABILITY_LABEL, AVAILABILITY_ROUTE, RESCHEDULE_VISIT_PAGE_PATH } from '../../utils/constants'
import { styles, text } from './Constants'
import { NewVisitHeader } from './components/new-visit-header/NewVisitHeader'
import { PatientInformation } from './components/patient-information/PatientInformation'
import { deleteBooking, setError } from '../../store/new-visit/NewVisitActions'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { cleanProviderName } from './helper'
import { statesOptions } from '../../utils/common'
import { useServiceTypes } from '@/hooks/useServiceTypes'
import { ReviewBook } from './components/review-book/ReviewBook'
import { NewVisitListener } from '../../store/new-visit/NewVisitListener'
import { usePatientSearch } from './hooks/usePatientSearch'
import { VisitInformationReschedule } from './components/visit-information/VisitInformationReschedule'
// Custom Hooks
import { useProviderInfo } from './hooks/useProviderInfo'
import { useTimeZone } from './hooks/useTimeZone'
import { usePaymentKeys } from './hooks/usePaymentKeys'
import { useBreadcrumbs } from './hooks/useBreadcrumbs'
import { useSecondaryClick } from './hooks/useSecondaryClick'
import { useInitializeVisitTypes } from './hooks/useInitializeVisitTypes'
import { usePopulateServiceVisitData } from './hooks/usePopulateServiceVisitData'
import { useHandleCardsAndReviewBook } from './hooks/useHandleCardsAndReviewBook'
import { useReschedulePrimaryClick } from './hooks/useReschedulePrimaryClick'
import {
  getVisitMethodFromMethodOption,
  NON_IN_PERSON_METHOD_OPTIONS,
  VisitMethodOptions,
  VisitMethods,
} from './components/visit-information/VisitMethods'

// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
const pageContainerStyle = {
  overflow: 'hidden',
}

export const NewVisitReschedule = () => {
  const { pathname, state: routeState } = useLocation()
  const locationState = routeState ?? {}

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isReschedulePage = pathname === RESCHEDULE_VISIT_PAGE_PATH

  // References
  const bookingId = useRef(locationState?.bookingId || '0')
  const patientId = useRef(locationState?.patient?.patientId)
  const useDefaultTime = useRef(locationState?.useDateTime)
  const reviewBookingRef = useRef()

  // Custom Hooks Integration
  const provider = useProviderInfo(locationState?.provider?.providerId, bookingId.current)
  const { currentTimeZone, zoneAbbr, zoneAbbrString } = useTimeZone(locationState?.customTimeZone)
  usePaymentKeys()

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const paymentKeys = useSelector((state) => state.newVisitReducer.paymentKeys)

  // Use the new breadcrumbs hook
  // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
  const breadCrumbs = useBreadcrumbs(locationState)
  console.log('breadCrumbs', breadCrumbs)

  // Selectors
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.newVisitReducer.visits[bookingId.current]?.error || '')
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.newVisitReducer.visits[bookingId.current]?.loading)

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loggedIn = useSelector((state) => state.auth.loggedIn)
  const cards = useSelector(
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    (state) => state?.newVisitReducer.visits[bookingId.current]?.cards,
    (a, b) => _.isEqual(a, b),
  )
  const { serviceTypes } = useServiceTypes()
  const isPhone = locationState?.visitMethod?.toLowerCase() === VisitMethodOptions.PHONE.toLowerCase()
  const isInPerson =
    locationState?.visitMethod?.toLowerCase() === VisitMethods.INPERSON.toLowerCase() ||
    locationState?.visitMethod?.toLowerCase() === VisitMethodOptions.IN_PERSON.toLowerCase()
  const isVideo = locationState?.visitMethod?.toLowerCase() === VisitMethodOptions.VIDEO.toLowerCase()
  const [showReviewBook, setShowReviewBook] = useState(false)
  const [visitOptions, setVisitOptions] = useState({})
  const [forcePaymentLoading, setForcePaymentLoading] = useState(false)
  const [patientVisitCredit, setPatientVisitCredit] = useState(0)
  const [selectedVisit, setSelectedVisit] = useState(null)
  const [selectedOption, setSelectedOption] = useState([
    { value: VisitMethodOptions.VIDEO, isChecked: isVideo },
    { value: VisitMethodOptions.PHONE, isChecked: isPhone },
    { value: VisitMethodOptions.IN_PERSON, isChecked: isInPerson },
  ])

  const selectedOptionValue = selectedOption.find((option) => option.isChecked)?.value

  const selectedMethod = selectedOptionValue ? getVisitMethodFromMethodOption(selectedOptionValue) : undefined

  const [visitTypes, setVisitTypes] = useState({})

  const [providerServiceVisitTypes, setProviderServiceVisitTypes] = useState([])
  const [providerServiceVisitNames, setProviderServiceVisitNames] = useState([])
  const [states, setStates] = useState(null)
  const [_price, setPrice] = useState(0)
  const [priceError, setPriceError] = useState('')
  const [methodCardError, setMethodCardError] = useState('')
  const [dateError, setDateError] = useState('')
  const [timeError, setTimeError] = useState('')
  const [visitError, setVisitError] = useState('')
  const [methodError, setMethodError] = useState('')
  const [stateError, setStateError] = useState('')
  const [_cardMethod, setCardMethod] = useState(null)
  const [mounted, setMounted] = useState(false)

  const [providerInfo, setProviderInfo] = useState({
    providerId: locationState?.provider?.providerId || null,
    providerName: cleanProviderName(locationState?.provider?.providerName || ''),
    dateTime: locationState?.clickedDateTime || '',
  })

  const {
    forceSearchLoading,
    showSearchResults,
    searchResults,
    selectedPatient,
    fullNameError,
    onSearchChanged,
    onPatientSelected,
    onSetShowResults,
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
  } = usePatientSearch(bookingId, navigate)

  const reschedulePrimaryClick = useReschedulePrimaryClick({
    showReviewBook,
    setShowReviewBook,
    visitOptions: {
      ...visitOptions,
      providerInfo,
      selectedMethod,
    },
    dispatch,
    state: locationState,
    currentTimeZone,
  })

  const handleSecondaryClick = useSecondaryClick({
    showReviewBook,
    state: locationState,
    bookingId,
    dispatch,
    navigate,
    setShowReviewBook,
  })

  const onAddCardSuccess = useCallback(() => {
    setForcePaymentLoading(false)
    if (methodCardError) setMethodCardError('')
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    reviewBookingRef?.current?.onAddCardSuccess()
  }, [methodCardError])

  const onBookVisitSuccess = useCallback(() => {
    navigate(-1)

    setTimeout(() => {
      dispatch(deleteBooking(bookingId.current))
    }, 1000)
  }, [dispatch, navigate])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onUpdateVisitCredit = useCallback((value) => {
    setPatientVisitCredit(value)
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onForceLoading = useCallback((value) => {
    setForcePaymentLoading(value)
  }, [])

  const onSetPrice = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      if (priceError) setPriceError('')
      setPrice(value)
    },
    [priceError],
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetCardMethod = useCallback((value) => {
    setCardMethod(value)
  }, [])

  // Restore the onSetVisitOptions function
  const onSetVisitOptions = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (options) => {
      const selectedOptions = { ...visitOptions, ...options }
      switch (selectedOptions.updateType) {
        case 'serviceVisitName':
          const selectedVisits = providerServiceVisitTypes
            .map((serviceVisit) => {
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              if (serviceVisit.ServiceVisitName === selectedOptions.serviceVisitName) {
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                selectedOptions.visitType = serviceVisit.Name
                return serviceVisit
              }
            })
            .filter((value) => value !== undefined)
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setSelectedVisit(selectedVisits[0])
          selectedOptions.selectedVisits = selectedVisits
          if (visitError) setVisitError('')
          break
        case 'method':
          if (methodError) setMethodError('')
          break
        case 'state':
          if (stateError) setStateError('')
          break
        case 'date':
          if (timeError === getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, text.TIME)) {
            if (selectedOptions.time) {
              setTimeError('')
            }
          } else if (timeError) setTimeError('')
          if (dateError) setDateError('')
          break
        default:
      }

      setVisitOptions((prev) => ({ ...prev, ...selectedOptions }))
    },
    [visitOptions, providerServiceVisitTypes, visitError, methodError, stateError, timeError, dateError],
  )

  useInitializeVisitTypes(serviceTypes, setVisitTypes)
  usePopulateServiceVisitData(
    serviceTypes,
    provider,
    visitTypes,
    setProviderServiceVisitTypes,
    setProviderServiceVisitNames,
  )
  useHandleCardsAndReviewBook(cards, mounted, setMounted, setShowReviewBook)

  // Effect: Handle Errors
  useEffect(() => {
    if (error) {
      setForcePaymentLoading(false)
      const timeout = setTimeout(() => {
        dispatch(setError('', bookingId.current))
        if (
          error === getUserFriendlyErrorMessage(errorCodes.DOES_NOT_EXIST_NO_REFRESH, null, text.PROVIDER) ||
          error === getUserFriendlyErrorMessage(errorCodes.CANNOT_BOOK_VISIT)
        ) {
          navigate(AVAILABILITY_ROUTE, { replace: true })
        }
      }, 3500)
      return () => clearTimeout(timeout)
    }
  }, [dispatch, error, navigate])

  useEffect(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (selectedVisit && visitOptions.selectedVisits) {
      if (stateError) setStateError('')

      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setPrice(selectedVisit?.Price)

      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const foundStates = visitOptions.selectedVisits
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .map((visit) => {
          let stateOption

          // Special handling for 'VI' and 'PR'
          if (visit.StateCode.toUpperCase() === 'VI') {
            stateOption = 'Virgin Islands VI'
          } else if (visit.StateCode.toUpperCase() === 'PR') {
            stateOption = 'Puerto Rico PR'
          } else {
            // Existing logic to find the state option
            stateOption = statesOptions.find((so) => {
              // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
              const stateCode = so.split(' ').pop().toUpperCase()
              return stateCode === visit.StateCode.toUpperCase()
            })
          }

          return stateOption ? { stateCode: visit.StateCode, stateOption } : null
        })
        .filter(Boolean) // Filter out any null or undefined values

      // Updated condition
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (selectedPatient && selectedVisit.IsLocationMatchRequired) {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        const patientStateCode = selectedPatient.Address.StateCode.toUpperCase()
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const filteredStates = foundStates.filter((item) => item.stateCode.toUpperCase() === patientStateCode)

        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        setStates(filteredStates.map((item) => item.stateOption))
      } else {
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const uniqueStates = [...new Set(foundStates.map((item) => item.stateOption))]
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setStates(uniqueStates.sort((a, b) => a.localeCompare(b)))
      }
    }

    if (selectedPatient) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setPatientVisitCredit(selectedPatient.CreditAmount)
    }
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  }, [selectedVisit, visitOptions.selectedVisits, selectedPatient])

  return (
    <>
      {forceSearchLoading || loading || forcePaymentLoading || !loggedIn ?
        <PageLoadingSpinner />
      : null}
      {error && loggedIn ?
        <ErrorAlert
          styleContainer={styles.ERROR_STYLE}
          errorText={error}
          errorImg={errorIcon}
          imgAlt='Error'
          iconStyle={styles.ERROR_ICON_STYLE}
        />
      : null}
      <NewVisitListener
        bookingId={bookingId.current}
        addCardSuccess={onAddCardSuccess}
        bookVisitSuccess={onBookVisitSuccess}
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        updateVisitCredit={onUpdateVisitCredit}
      />
      <div className='new-visit-container'>
        <NewVisitHeader
          dontShow={isReschedulePage ? !showReviewBook : null}
          primaryClick={reschedulePrimaryClick}
          secondaryClick={handleSecondaryClick}
          isReviewBook={showReviewBook}
        />

        {/*
         // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
        <div className='new-visit-body-container' style={showReviewBook ? styles.OFF_SCREEN : null}>
          <PatientInformation
            searchChanged={onSearchChanged}
            searchResults={showSearchResults ? searchResults : null}
            patientSelected={onPatientSelected}
            setIsSearchActive={onSetShowResults}
            fullNameError={fullNameError}
            show={!showReviewBook}
            provider={provider || locationState?.provider || {}}
            visitOptions={visitOptions}
            timeZone={locationState?.customTimeZone || currentTimeZone}
            visitTimeZone={locationState?.visitTimeZone}
            visitTime={locationState?.visitTime}
          />
          <VisitInformationReschedule
            provider={provider || locationState?.provider || {}}
            defaultDateTime={locationState?.clickedDateTime}
            serviceVisitNames={providerServiceVisitNames}
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            methods={NON_IN_PERSON_METHOD_OPTIONS}
            states={states}
            setVisitOptions={onSetVisitOptions}
            dateError={dateError}
            timeError={timeError}
            stateError={stateError}
            methodError={methodError}
            visitError={visitError}
            zoneAbbr={zoneAbbr.current}
            zoneAbbrString={zoneAbbrString}
            timeZone={locationState?.customTimeZone || currentTimeZone}
            show={!showReviewBook}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            patientState={selectedPatient?.Address?.StateCode}
            useDefaultTime={useDefaultTime.current}
            providerServiceVisitTypes={providerServiceVisitTypes}
            bookingId={bookingId.current}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            visitTypeId={selectedVisit?.VisitTypeId}
            patientId={patientId?.current}
            reschedulePrimaryClick={reschedulePrimaryClick}
            setProviderInfo={setProviderInfo}
            initialProviderName={cleanProviderName(locationState?.provider?.providerName)}
            setSelectedOption={setSelectedOption}
          />
        </div>
        {/*
         // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
        <div className='new-visit-review-body-container' style={!showReviewBook ? styles.OFF_SCREEN : null}>
          <ReviewBook
            ref={reviewBookingRef}
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            bookingId={bookingId.current}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            visitInfo={{ ...visitOptions, providerInfo, price: selectedVisit?.Price }}
            isReschedule={isReschedulePage}
            selectedPatient={selectedPatient}
            creditAmount={patientVisitCredit}
            show={showReviewBook}
            zoneAbbrString={zoneAbbrString}
            timeZone={locationState?.customTimeZone}
            paymentKeys={paymentKeys}
            forceLoading={onForceLoading}
            setPrice={onSetPrice}
            methodError={methodCardError}
            priceError={priceError}
            setCardMethod={onSetCardMethod}
            setMethodCardError={setMethodCardError}
            onBookVisitSuccess={onBookVisitSuccess}
            setSelectedOption={setSelectedOption}
            selectedOption={selectedOption}
          />
        </div>
      </div>
    </>
  )
}
